<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="well-title">
        <div class="col-md-12">PTP Departments</div>
    </div>
    <div class="col-md-12 well-content">
        <div style="margin-bottom: 16px; display: flex; gap: 8px; align-items: center">
            <button nz-button nzType="primary" (click)="addDepartment()">Add Department</button>
        </div>
        <nz-table #departmentTable [nzData]="departments" nzTableLayout="fixed" nzBordered="true" [nzLoading]="loading">
            <thead>
                <tr>
                    <th>Department Name</th>
                    <th nzWidth="160px"></th>
                </tr>
            </thead>
            <tbody>
                @for (department of departmentTable.data; track department.DepartmentID) {
                    <tr>
                        <td>{{ department.DepartmentName }}</td>
                        <td style="text-align: center">
                            <button nz-button class="btn btn-default" (click)="editDepartment(department.DepartmentID)">
                                Edit
                            </button>
                            <button
                                nz-button
                                nzDanger
                                style="margin-left: 8px"
                                nz-popconfirm
                                nzPopconfirmTitle="Are you sure you want to delete this department?"
                                (nzOnConfirm)="deleteDepartment(department.DepartmentID)">
                                Delete
                            </button>
                        </td>
                    </tr>
                }
            </tbody>
        </nz-table>
    </div>
</div>
